import { useEffect, useState } from "react";
import { api } from "../api";

export function AppSettings() {
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    api.getSettings().then(setData).catch(console.error);
  }, []);

  if (!data) return <div className="p-8 text-zinc-500">Yükleniyor…</div>;

  return (
    <div className="p-8 max-w-2xl">
      <h2 className="text-lg font-bold mb-4">Settings</h2>

      <section className="bg-white border rounded p-5 mb-4">
        <h3 className="font-bold mb-3">Secrets durumu</h3>
        <ul className="text-sm space-y-1">
          {Object.entries(data.keys).map(([k, v]) => (
            <li key={k} className="flex justify-between">
              <span className="font-mono text-xs">{k}</span>
              <span className={v ? "text-emerald-600" : "text-red-500"}>
                {v ? "set" : "missing"}
              </span>
            </li>
          ))}
        </ul>
        <p className="mt-3 text-xs text-zinc-500">
          Secrets <code>wrangler secret put</code> ile yüklenir.
        </p>
      </section>

      <section className="bg-white border rounded p-5">
        <h3 className="font-bold mb-3">Drive editor</h3>
        <div className="text-sm">
          Klasörlere otomatik erişim: <code>{data.drive_editor_email}</code>
        </div>
      </section>
    </div>
  );
}
